import { type InactivityTracker } from 'hb-react/shared/utils/InactivityPublisher/trackers/InactivityTracker';

export class InactivityPublisher {
  public isActive: boolean;
  private onActiveObservers: Array<() => void> = [];
  private onInactiveObservers: Array<() => void> = [];

  constructor(private readonly trackers: Array<InactivityTracker>) {
    this.isActive = true;
    this.onActiveObservers = [];
    this.onInactiveObservers = [];

    // Bind handlers to the instance to ensure "this" context
    this.active = this.active.bind(this);
    this.inactive = this.inactive.bind(this);
    this.handleTrackerChange = this.handleTrackerChange.bind(this);

    this.trackers = trackers;

    this.init();
  }

  private init() {
    this.trackers.forEach((tracker) => tracker.init(this.handleTrackerChange));
  }

  public destroy() {
    this.trackers.forEach((tracker) => {
      tracker.destroy();
    });
  }

  private handleTrackerChange() {
    const newIsActive = this.trackers.every((tracker) => tracker.isActive);

    if (this.isActive === newIsActive) {
      return;
    }

    if (newIsActive) {
      this.active();
    } else {
      this.inactive();
    }
  }

  private active() {
    this.isActive = true;
    this.onActiveObservers.forEach((handler) => handler());
  }

  private inactive() {
    this.isActive = false;
    this.onInactiveObservers.forEach((handler) => handler());
  }

  public subscribeToOnActive(handler?: () => void) {
    if (!handler) {
      return;
    }
    this.onActiveObservers.push(handler);
  }

  public unsubscribeFromOnActive(handler?: () => void) {
    if (!handler) {
      return;
    }
    this.onActiveObservers = this.onActiveObservers.filter(
      (h) => h !== handler,
    );
  }

  public subscribeToOnInactive(handler?: () => void) {
    if (!handler) {
      return;
    }
    this.onInactiveObservers.push(handler);
  }

  public unsubscribeFromOnInactive(handler?: () => void) {
    if (!handler) {
      return;
    }
    this.onInactiveObservers = this.onInactiveObservers.filter(
      (h) => h !== handler,
    );
  }
}
